import { translate } from '../../../Services/translation';
import { mixed, number, object, ref, string } from 'yup';

const requiredTranslation = translate('validation.required');

export const ReturnFormItemValidationSchema = object().shape({
  orderNumber: string().nullable().max(20).required(requiredTranslation),
  articleNumber: string().nullable().max(30).required(requiredTranslation),
  batchNumber: string().nullable().max(30).required(requiredTranslation),
  quantity: number().nullable().required(requiredTranslation),
  errorCode: string().nullable().required(requiredTranslation),
});

export const ReturnFormValidationSchema = object().shape({
  returnType: string().nullable().required(requiredTranslation),
});
